import { App } from 'vue'
import flagsmith, { IFlagsmith } from 'flagsmith'

export const FeatureFlags = ['feature/refer_a_friend', 'feature/zendesk_widget'] as const

// This type gives us intellisense on the strings defined in FeatureFlags and also allow any string
export type FeatureFlagKey = (typeof FeatureFlags)[number] & (string & {})

export interface FlagSmithPluginOptions {
  environmentID: string
  cacheFlags: boolean
  enableAnalytics: boolean
}

export const FlagsmithKey = Symbol('flagsmith')

const flagSmithPlugin = {
  install: (app: App) => {
    const context: IFlagsmith<FeatureFlagKey> = flagsmith

    // Provide immediately (synchronous) so inject always finds it
    app.config.globalProperties.$flagsmith = context
    app.provide(FlagsmithKey, context)

    // Initialize in background
    flagsmith.init({
      environmentID: import.meta.env.VITE_FLAGSMITH_SDK_KEY,
      cacheFlags: true,
      enableAnalytics: false,
    })
  },
}

export default flagSmithPlugin
